var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cmp-totals" }, [
    _c(
      "div",
      {
        staticClass: "component-loading with-icon refreshing",
        class: { "is-loading": _vm.isBasketLoading },
      },
      [
        _c(
          "dl",
          [
            _vm._t("before-item-sum"),
            _vm._v(" "),
            _vm.visibleFields.includes("basketValueNet") &&
            _vm.currentPriceType === "b2b"
              ? [
                  _c("dt", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$translate("Ceres::Template.basketValue")) +
                        " (" +
                        _vm._s(_vm.$translate("Ceres::Template.basketNet")) +
                        ")\n                    "
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.calculateBaseValue(
                              _vm.basket.itemSumNet,
                              _vm.basket.basketRebate
                            )
                          )
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("basketValueGross") &&
            _vm.currentPriceType === "b2c"
              ? [
                  _c("dt", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$translate("Ceres::Template.basketValue")) +
                        " (" +
                        _vm._s(_vm.$translate("Ceres::Template.basketGross")) +
                        ")\n                    "
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.calculateBaseValue(
                              _vm.basket.itemSum,
                              _vm.basket.basketRebate
                            )
                          )
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("rebate") && _vm.basket.basketRebate
              ? [
                  _c("dt", { staticClass: "rebate-hint" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$translate("Ceres::Template.basketRebate")) +
                        "\n                    "
                    ),
                  ]),
                  !_vm.showNetPrices
                    ? _c("dd", { staticClass: "rebate-hint" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.calculateBaseValue(
                                  _vm.basket.itemSum,
                                  _vm.basket.basketRebate
                                ) - _vm.basket.itemSum
                              )
                            ) +
                            "\n                    "
                        ),
                      ])
                    : _c("dd", { staticClass: "rebate-hint" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.calculateBaseValue(
                                  _vm.basket.itemSumNet,
                                  _vm.basket.basketRebate
                                ) - _vm.basket.itemSumNet
                              )
                            ) +
                            "\n                    "
                        ),
                      ]),
                  _vm._v(" "),
                  _c(
                    "dt",
                    { class: { "font-weight-bold": _vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketSubTotal")
                          ) +
                          " (" +
                          _vm._s(_vm.$translate("Ceres::Template.basketNet")) +
                          ")\n                    "
                      ),
                    ]
                  ),
                  _c(
                    "dd",
                    { class: { "font-weight-bold": _vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm._f("currency")(_vm.basket.itemSumNet)) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "dt",
                    { class: { "font-weight-bold": !_vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketSubTotal")
                          ) +
                          " (" +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketGross")
                          ) +
                          ")\n                    "
                      ),
                    ]
                  ),
                  _c(
                    "dd",
                    { class: { "font-weight-bold": !_vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm._f("currency")(_vm.basket.itemSum)) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._t("after-item-sum"),
            _vm._v(" "),
            _vm._t("before-shipping-costs"),
            _vm._v(" "),
            _vm.visibleFields.includes("shippingCostsNet") &&
            _vm.currentPriceType === "b2b"
              ? [
                  _c("dt", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.basketShippingCosts")
                        ) +
                        " (" +
                        _vm._s(_vm.$translate("Ceres::Template.basketNet")) +
                        ")\n                    "
                    ),
                  ]),
                  _c(
                    "dd",
                    { class: { "font-weight-bold": _vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm._f("currency")(_vm.basket.shippingAmountNet)
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("shippingCostsGross") &&
            _vm.currentPriceType === "b2c"
              ? [
                  _c("dt", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.basketShippingCosts")
                        ) +
                        " (" +
                        _vm._s(_vm.$translate("Ceres::Template.basketGross")) +
                        ")\n                    "
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm._f("currency")(_vm.basket.shippingAmount)) +
                        "\n                    "
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._t("after-shipping-costs"),
            _vm._v(" "),
            _vm.visibleFields.includes("promotionCoupon") &&
            _vm.basket.couponCode &&
            _vm.basket.couponCampaignType === "promotion"
              ? [
                  _c("dt", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$translate("Ceres::Template.basketCoupon")) +
                        "\n                    "
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm._f("currency")(_vm.basket.couponDiscount)) +
                        "\n                    "
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._t("before-total-sum"),
            _vm._v(" "),
            _vm._t("before-vat"),
            _vm._v(" "),
            _vm._t("after-vat"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "totalSum" },
              [
                _vm.visibleFields.includes("totalSumGross") &&
                _vm.currentPriceType === "b2c"
                  ? [
                      _c(
                        "dt",
                        { class: { "font-weight-bold": !_vm.showNetPrices } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.basketTotalSum")
                              ) +
                              " (" +
                              _vm._s(
                                _vm.$translate("Ceres::Template.basketGross")
                              ) +
                              ")\n                        "
                          ),
                        ]
                      ),
                      _c(
                        "dd",
                        { class: { "font-weight-bold": !_vm.showNetPrices } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("currency")(_vm.basket.basketAmount)
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.visibleFields.includes("totalSumNet") &&
                _vm.currentPriceType === "b2b"
                  ? [
                      _c(
                        "dt",
                        { class: { "font-weight-bold": _vm.showNetPrices } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.basketTotalSum")
                              ) +
                              " (" +
                              _vm._s(
                                _vm.$translate("Ceres::Template.basketNet")
                              ) +
                              ")\n                        "
                          ),
                        ]
                      ),
                      _c(
                        "dd",
                        { class: { "font-weight-bold": _vm.showNetPrices } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm._f("currency")(_vm.basket.basketAmountNet)
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.visibleFields.includes("salesCoupon") &&
                _vm.basket.couponCode &&
                _vm.basket.couponCampaignType === "sales"
                  ? [
                      _c("dt", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.basketCoupon")
                            ) +
                            "\n                        "
                        ),
                      ]),
                      _c("dd", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._f("currency")(_vm.basket.couponDiscount)
                            ) +
                            "\n                        "
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.visibleFields.includes("openAmount") &&
                _vm.basket.couponCampaignType === "sales"
                  ? [
                      _c("dt", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.basketOpenAmount")
                            ) +
                            "\n                        "
                        ),
                      ]),
                      _c("dd", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm._f("currency")(_vm.basket.openAmount)) +
                            "\n                        "
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm._t("after-total-sum"),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _vm.basket.isExportDelivery && _vm.deliveryExportTranslation
      ? _c("div", { staticClass: "alert alert-info w-100" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.deliveryExportTranslation) +
              "\n        "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }